import Highcharts from 'highcharts';

import initExporting from 'highcharts/modules/exporting';
import initOfflineExporting from 'highcharts/modules/offline-exporting';
import initNoData from 'highcharts/modules/no-data-to-display';
import exportData from 'highcharts/modules/export-data';
import highchartsCustomEvents from 'highcharts-custom-events';

initExporting(Highcharts);
initOfflineExporting(Highcharts);
initNoData(Highcharts);
exportData(Highcharts);
highchartsCustomEvents(Highcharts);

Highcharts.setOptions({
  colors: [
    '#EE5848',
    '#FCB925',
    '#25A8A2',
    '#1D7BB9',
    '#9097AB',
    '#4753A7',
    '#4A90E2',
    '#0CBA6A',
    '#FA9A30',
    '#FF7979',
    '#9097AB',
    '#A2C5ED'
  ],
  exporting: {
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        menuItems: [
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadSVG',
          'separator',
          'downloadCSV',
          'downloadXLS'
        ]
      }
    },
    chartOptions: {
      chart: {
        width: 900,
        height: 700
      }
    }
  },
  visitCountColor: 'rgba(112, 178, 255, 0.5)',
  storeCountColor: 'rgba(161, 161, 161, 0.5)'
});
